import { type MaybeRefOrGetter } from 'vue';
import { viewListMaxTime } from '@store/itinerary';

interface Options {
    onTimeout: () => void;
    overrideCondition?: MaybeRefOrGetter<boolean>;
}

export default function useReload(options?: Options) {
    const { overrideCondition, onTimeout } = options || {};
    const timeoutShown = ref(false);
    const lastShowTime = ref<Date>();
    const interval = ref<number>();
    const i18n = useI18n();
    const checkCondition = () => {
        if (overrideCondition) {
            return toValue(overrideCondition);
        } else {
            return (
                dayConfig
                    .gregory()
                    .diff(dayConfig.gregory(lastShowTime.value)) >=
                viewListMaxTime
            );
        }
    };
    function start() {
        lastShowTime.value = new Date();
        interval.value = window.setInterval(async () => {
            if (checkCondition() && !timeoutShown.value) {
                timeoutShown.value = true;
                const { isConfirmed } = await swal({
                    text: i18n.t('timeout.notUpdatedInfo'),
                    icon: 'warning',
                    showConfirmButton: true,
                    confirmButtonText: i18n.t('timeout.update'),
                    showCancelButton: true,
                    cancelButtonText: i18n.t('timeout.ok'),
                });
                if (isConfirmed) {
                    onTimeout?.();
                    timeoutShown.value = false;
                    lastShowTime.value = new Date();
                }
            }
        }, 1000);
    }

    function stop() {
        window.clearInterval(interval.value);
        interval.value = undefined;
    }

    function forceReset() {
        timeoutShown.value = false;
        lastShowTime.value = new Date();
    }

    return {
        start,
        stop,
        forceReset,
    };
}
